import React from "react";

const LeadSubmissionPage = ({
  screen,
  leadSubmitError,
  leadSubmitting,
  submitLeadAndContinue,
  setScreen,
}) => {
  if (screen === "leadSubmitting") {
    return (
      <section className="fw-screen fw-screen--plain fw-fade fw-submit-wait">
        <div
          className="fw-submit-wait__spinner"
          aria-hidden="true"
        />

        <h1 className="fw-title">
          Submitting your application
        </h1>

        <p className="fw-sub">
          Please wait while we save your details securely.
        </p>
      </section>
    );
  }

  if (screen === "leadSubmitFail") {
    return (
      <section className="fw-screen fw-screen--plain fw-fade fw-submit-fail">
        <h1 className="fw-title">
          Application could not be submitted
        </h1>

        <p className="fw-error fw-submit-fail__msg">
          {leadSubmitError || "Please try again."}
        </p>

        <div className="fw-actions">
          <button
            type="button"
            className="fw-btn fw-btn--ghost"
            onClick={() =>
              setScreen("/apply-new/selfieCapture")
            }
          >
            Back
          </button>

          <button
            type="button"
            className="fw-btn fw-btn--primary"
            onClick={() =>
              submitLeadAndContinue()
            }
            disabled={leadSubmitting}
          >
            {leadSubmitting
              ? "Submitting..."
              : "Retry"}
          </button>
        </div>
      </section>
    );
  }

  return null;
};

export default LeadSubmissionPage;